import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual"
import { clearSearchData,
} from "../../store/actions/doctorActions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class Search extends Component {



    clearSearch = (e) => {
        e.preventDefault();
        localStorage.removeItem("searchData");
        this.props.clearSearchData();
        this.props.history.push({pathname: "doctors"})
    };

    render() {
        return (
            <section className="subscribe" id="search">
                <div className="container" style={this.props.sliders && this.props.sliders.length === 0 && this.props.mobileMenuIsShown ? {marginTop: "65px"} : null }>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="flex-container">
                                <div className="subscribe-flex-half image-search height-490"></div>

                                <div className="subscribe-flex-half  form text-center flex flex-direction-col justify-content-center">
                                    <h2 className="text-center capitalized">{this.props.translate('search_for_doctor')}</h2>
                                    <p className="text-center capitalized font-20">{this.props.translate('find_the_best_doctor_now_easily')}</p>
                                    <a onClick={(e) => this.clearSearch(e)} className="btn btn-primary btn-home-search capitalized">
                                        <span>{this.props.translate('find_doctor_now')}  <i className="fa fa-search"></i></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


const mapStateToProps = (state) => {

    return {
        currentSearchData: state.doctor.currentSearchData,

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        clearSearchData: () => dispatch(clearSearchData()),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(withRouter(Search)));


/// References ////////
//// https://www.npmjs.com/package/izitoast/v/1.0.2




